export const aboutInfo = {
  brandName: '51黑料网',
  slogan: '全网爆料第一入口',
  description: '51黑料网成立于2024年，是中国领先的网红主播爆料与娱乐八卦资讯平台。我们致力于为广大网友提供真实、及时、深度的爆料内容，让每一个人都能掌握网红圈与娱乐圈的最新动态。',
  mission: '揭露真相，还原真实，让阳光照进每一个角落',
  stats: [
    { label: '实时爆料', value: '24H', suffix: '不间断更新' },
    { label: '全网覆盖', value: '500+', suffix: '网红主播' },
    { label: '独家内容', value: '100+', suffix: '独家猛料/月' },
    { label: '累计曝光', value: '10亿+', suffix: '次阅读量' },
  ],
  features: [
    {
      title: '实时更新',
      description: '7×24小时不间断更新，确保您第一时间获取最新爆料动态',
      icon: 'ri-time-line',
    },
    {
      title: '独家首发',
      description: '专业的爆料团队深入一线，为您带来全网独家的第一手资料',
      icon: 'ri-vip-crown-line',
    },
    {
      title: '深度追踪',
      description: '不止于表面爆料，我们深入调查事件背后的真相与逻辑',
      icon: 'ri-search-line',
    },
  ],
  contact: {
    email: 'hello@lalaxjk.cn',
    wechat: 'HeiLiao51',
    weibo: '@51黑料网官方',
    address: '中国·北京',
  },
  disclaimer: '51黑料网所有内容均来源于网络及用户投稿，仅供参考。我们尊重每一位当事人的合法权益，如内容涉及侵权，请及时联系我们删除。',
};